import { type DeviceType } from '@sine/id-api-types';

export enum PassStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
}
export enum PassPseudoStatus {
  WATCHLIST_FLAGGED = 'watchlist-flagged',
  AUTO_EXPIRED = 'auto-expired',
}

export enum PassStatusInvitation {
  ARRIVING_SOON = 'arriving-soon',
}

export interface ActivityQueryFilters {
  siteIds: Array<string>;
  startDate?: number;
  endDate?: number;
  searchTerm?: string;
  limit: number;
  autoExpired?: boolean;
  deviceTypes: Array<`${DeviceType}`>;
  status: Array<`${PassStatus}` | `${PassPseudoStatus}` | `${PassStatusInvitation}`>;
}

export enum PassStatusInactive {
  REJECTED = PassStatus.REJECTED,
  EXPIRED = PassStatus.EXPIRED,
  WATCHLIST_FLAGGED = PassPseudoStatus.WATCHLIST_FLAGGED,
  AUTO_EXPIRED = PassPseudoStatus.AUTO_EXPIRED,
}

export enum PassStatusActive {
  ACTIVE = PassStatus.ACTIVE,
  PENDING = PassStatus.PENDING,
  WATCHLIST_FLAGGED = PassPseudoStatus.WATCHLIST_FLAGGED,
}

export interface InactivePassesQuery extends Omit<ActivityQueryFilters, 'status'> {
  status: Array<`${PassStatusInactive}`>;
}

export interface ActivePassesQuery extends Omit<ActivityQueryFilters, 'status'> {
  status: Array<`${PassStatusActive}`>;
}
